<template>
  <div>
    <div class="row">
      <div class="col-md-12 grid-margin">
        <div class="row">
          <div class="col-12 mb-0 mb-xl-0">
            <h4 class="font-weight-bold">My Merchants</h4>
          </div>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table id="merchant-listing" class="table">
        <thead>
          <tr>
            <th>Company Name</th>
            <th>Email</th>
            <th>Mobile Number</th>
            <th>Business Category</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="merchant in merchants" :key="merchant.uuid">
            <td>{{ merchant.companyName }}</td>
            <td>{{ merchant.email }}</td>
            <td>{{ merchant.mobileNumber }}</td>
            <td>{{ merchant.businessCategory }}</td>
            
            <td>
              <router-link :to="'/merchant/profile/' + merchant.uuid" class="btn btn-md btn-outline-primary ml-2" data-toggle="tooltip" title="Manage Merchant">
                <i class="fa fa-cog"></i>
              </router-link>
              <router-link :to="'/merchant/trxns/' + merchant.uuid" class="btn btn-md btn-outline-info ml-2" data-toggle="tooltip" title="View Transactions">
                <i class="fa fa-money-bill"></i>
              </router-link>
              <button class="btn btn-md btn-outline-danger ml-2" @click="deleteMerchant(merchant.uuid)" data-toggle="tooltip" title="Delete Merchant">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
import api from "@/shared/menuApi";

export default {
  name: "MyMerchants",
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      merchants: []
    };
  },
  methods: {
    async getMerchants() {
      try {
        const adminUuid = localStorage.getItem("uuid");
        const response = await api.doGet('/api/admin/merchants/' + adminUuid);
        if (response.status === "00") {
          this.merchants = response.data;
        } else {
          this.toast.error(response.message || "Failed to fetch merchants");
        }
      } catch (error) {
        console.error("Error fetching merchants:", error);
        this.toast.error("An error occurred while fetching merchants");
      }
    },
    async deleteMerchant(uuid) {
      if (confirm("Are you sure you want to delete this merchant?")) {
        try {
          const response = await api.doPost('/merchant/delete', { uuid });
          
          if (response.status === "00") {
            this.toast.success(response.message);
            this.getMerchants();
          } else {
            this.toast.error(response.message || "Failed to delete merchant");
          }
        } catch (error) {
          console.error("Error deleting merchant:", error);
          this.toast.error("An error occurred while deleting the merchant");
        }
      }
    }
  },
  mounted() {
    this.getMerchants();
  }
};
</script>

<style scoped>
.table {
  margin-top: 20px;
}
</style> 